// extracted by mini-css-extract-plugin
export var preparedEntitlementsTools = "prepared-entitlements__tools_E10iu9FmNergqfRE5XCC";